
export enum BillTypeCd {
	COLLECT = 'Collect',
	PREPAID = 'Prepaid',
	THIRD_PARTY = 'ThirdParty'}

